import dayjs from 'dayjs';
import Commons from '../../../../Services/Common/Common';

export const SAT_BASIC_03_Schema = {
  fields: {
    no: { initial: '', label: '행 식별자' },
    newYn: { initial: 'N', label: '신규 여부' },

    chaebun: { initial: '', label: '채번' },
    eduNm: { initial: '', label: '교육명' },
    safetyDay: { initial: '', label: '구분' },

    oneM: { initial: '', label: '1월' },
    twoM: { initial: '', label: '2월' },
    threeM: { initial: '', label: '3월' },
    fourM: { initial: '', label: '4월' },
    fiveM: { initial: '', label: '5월' },
    sixM: { initial: '', label: '6월' },
    sevenM: { initial: '', label: '7월' },
    eightM: { initial: '', label: '8월' },
    nineM: { initial: '', label: '9월' },
    tenM: { initial: '', label: '10월' },
    elevenM: { initial: '', label: '11월' },
    twelveM: { initial: '', label: '12월' },

    createDate: { initial: '', label: '생성일자' },
    createId: { initial: '', label: '생성자' },
    updateDate: { initial: '', label: '수정일자' },
    updateId: { initial: '', label: '수정자' },
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      SafetyDate: (_, context) =>
        Commons.EncryptAES(
          dayjs(context.search?.searchYear).format('YYYY') || ''
        ),
      UserId: (_, context) => context.userInfo?.userid || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || ''),
    },

    save1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || ''),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      EduNm: (row) => Commons.EncryptAES(row.eduNm || ''),
      SafetyDate: (_, context) =>
        Commons.EncryptAES(
          dayjs(context.search?.searchYear).format('YYYY') || ''
        ),
      SafetyDay: (row) => Commons.EncryptAES(row.safetyDay || ''),

      OneM: (row) => Commons.EncryptAES(row.oneM || ''),
      TwoM: (row) => Commons.EncryptAES(row.twoM || ''),
      ThreeM: (row) => Commons.EncryptAES(row.threeM || ''),
      FourM: (row) => Commons.EncryptAES(row.fourM || ''),
      FiveM: (row) => Commons.EncryptAES(row.fiveM || ''),
      SixM: (row) => Commons.EncryptAES(row.sixM || ''),
      SevenM: (row) => Commons.EncryptAES(row.sevenM || ''),
      EightM: (row) => Commons.EncryptAES(row.eightM || ''),
      NineM: (row) => Commons.EncryptAES(row.nineM || ''),
      TenM: (row) => Commons.EncryptAES(row.tenM || ''),
      ElevenM: (row) => Commons.EncryptAES(row.elevenM || ''),
      TwelveM: (row) => Commons.EncryptAES(row.twelveM || ''),

      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      Chaebun: (row) => Commons.EncryptAES(row.chaebun || ''),
    },
  },
};
